import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';

import bikerelocation from "../images/Bike Relocation New Town.jpg";
import bikerelocationpnewtown from "../images/Bike Movers.jpeg";
import bikerelocationpackersmovers from "../images/bike photo.jpg";
import bikeshifting from "../images/Bike Shift.jpeg";


import bikerelocationphoto from "../images/BIKE.jpg"
function BikeRelocation() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="Gray"/>
      <div className='packermovershoogle'>
        <div className="album py-0">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#"><small>Home</small></Link></li>
                <li className="breadcrumb-item active" aria-current="page"><small>Bike Relocation</small></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
 <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-2">
              
                    <img src={bikerelocationphoto} className="d-block w-100" alt="bikerelocationphoto"/>
              </div>
               <div className="col-md-4 mt-2">
                <div className='packer_Rajarhatkolkata'>
                  <Contactform/>
                </div>
              </div>
              </div>
              </div>
            </div>
            <br/>
    
         <div className='bikerelocation'>
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-3">
              
                               <button className='iba'>IBA Approved Packers and Movers</button>
                <h1 style={{ fontSize: "3rem", color: "#050278" }} className="card-text mb-0"> <b>Best Bike Relocation Services in India</b></h1>
</div>
                <h6 style={{ color: "#050278" }} className="card-text mb-5 mt-4">We specialize in safe and hassle-free bike relocation services across India. Based in New Town, our team uses advanced equipment and skilled handlers to ensure your bike is transported with complete care, precision, and safety.</h6>
                
   <h1 className="card-text " style={{ margin: "auto 0", color: "#050278" }}> <b> Best Bike Relocation Services in :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "#050278" }}>
                <Typewriter
                  loop
                  cursor
                  cursorStyle="_"
                  typeSpeed={100}
                  deleteSpeed={50}
                  delaySpeed={1000}
                  words={["New Town", "Hoogle", "Durgapur", "Bengalore", "Delhi", "Siliguri", "Murshidabad", "Bengalore", "Chennei", "Rajasthan"]}
                />
              </span>
              </b></h1>
               <div className="indiastrustedwebsitedevelopment">
                <h3 style={{ fontSize: "1rem", color: "#050278" }} className="card-text mb-8 mt-2"> <b>AT INDIA PACKERS MOVERS</b></h3>
              </div>
              </div>
             
            </div>
        
        </div>
        <br />
        <br />
        <br />




      </div>
     
      <div className='grey'>
         <br />
        <div className="album py-1">

          <div className="container">
      <center><h2 style={{color:"#05438e"}}>How does it Work?</h2></center>
      </div>
      </div>
       <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
<WorkProcess/>
              </div>
               <div className="col-md-4 mt-4">
                                 <div className="card" >
  <img src={helpdeskdetails} className="card-img-top" alt="helpdeskdetails"/>
  <div className="card-body">
    <h5 style={{color:"#05438e"}} className="card-title"><center>Helpful Details</center></h5>
    <p className="card-text">Packing tips</p>
  
  </div>
</div>

              </div>
              </div>
              </div>
            </div>
       <br />
      
<div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                  <img src={bikerelocation} className="card-img-top" alt="bikerelocation"/>

                </div>
                <div className="col-md-3 mt-3">
                  <img src={bikerelocationpnewtown} className="card-img-top" alt="bikerelocationpnewtown"/>

                </div>
                <div className="col-md-3 mt-3">
                  <img src={bikerelocationpackersmovers} className="card-img-top" alt="bikerelocationpackersmovers"/>

                </div>
                <div className="col-md-3 mt-3">
                  <img src={bikeshifting} className="card-img-top" alt="bikeshifting"/>

                </div>
                </div>
                </div>
              </div>
              <br />
      </div>
      
      <ShiftingProcess/>
  

      <Callback/>

     
    </div>
  )
}

export default BikeRelocation